import React from 'react';
import { ServiceProvider } from './src/context/LoaderContext';
// import PageTransition from "./src/components/PageTransition";

import 'sal.js/dist/sal.css';
import "./src/styles/global.css"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export const wrapRootElement = ({ element }) => (
    <ServiceProvider>
        {element}
        {/* <PageTransition>{element}</PageTransition> */}
    </ServiceProvider>
);